import styled from 'styled-components';

export const ContainerFinancialToPayList = styled.div`
  max-height: 500px;
  overflow: auto;
`;
